import { v4 as generateUUID } from 'uuid';
import { Aggregation, Resolution, ResourceType } from '@/clients/dashboardapi/v2';
import type { WidgetConfig } from '@/modules/ctx-dashboard';
import { WidgetType } from '@/modules/ctx-dashboard';
import type { WidgetPreset } from '@/components/widget-wizard';
import { Port } from '@/modules/shared/Port';

export default class LatestLogs implements WidgetPreset {

    public readonly name: string = 'latest-logs';
    public readonly type: WidgetType = WidgetType.LatestLogs;
    public readonly quickAdd: boolean = false;
    public readonly order: number = 30;
    public readonly metrics: string[] = [];

    public async createWidget(params: { portfolio: string; dashboard: string }): Promise<WidgetConfig> {
        return {
            key: '',
            portfolioKey: params.portfolio,
            dashboardKey: params.dashboard,
            config: {
                logConfig: {
                    eventNamesBlacklist: [],
                },
            },
            order: 0,
            type: this.type,
            preset: this.name,
            title: '',
            generatedTitle: '',
            intervalName: 'this-month-complete',
            intervalFrom: new Date(),
            intervalTo: new Date(),
            resolution: Resolution.Min10,
            axis: [{
                name: '',
                unit: '',
                config: {},
                metrics: [{
                    uuid: generateUUID().substring(0, 8),
                    metricKey: '',
                    metricName: '',
                    metricCategory: '',
                    metricUnit: '',
                    aggregationOverTime: Aggregation.Avg,
                    resources: [{
                        uuid: generateUUID().substring(0, 8),
                        seriesName: '',
                        resourceName: (await Port.portfolios.getPortfolioByKey(params.portfolio))?.name || '',
                        type: ResourceType.Portfolio,
                        resourceKey: params.portfolio,
                        aggregationOverGenerators: Aggregation.Avg,
                        config: {},
                    }],
                }],
            }],
        };
    }
}
